import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {IconProp} from 'ngx-satoris';
import {compressFile} from 'src/app/shared/utils/compressImage';

@Component({
  selector: 'app-id-photo-input',
  templateUrl: './id-photo-input.component.html',
  styleUrl: './id-photo-input.component.scss'
})
export class IdPhotoInputComponent {
  @Input() icon: IconProp;
  @Input() labelKey: string;
  @Input() description: string = '';
  @Input() hasValue: boolean = false;
  @Input() value: string | undefined;
  @Output() captured = new EventEmitter<string>();

  showWebcam: boolean = false;
  fileName: string = null;
  inputForm: FormGroup;
  displayPreview: boolean = false;

  constructor(private formBuilder: FormBuilder) {
    this.inputForm = this.formBuilder.group({
      webcam_input: ['']
    });
  }
  openCamera() {
    this.showWebcam = true;
  }

  closeCamera() {
    this.showWebcam = false;
  }

  toggleDisplayPreview() {
    this.displayPreview = !this.displayPreview;
  }

  async onCaptured(base64Image: string) {
    if(!base64Image) return;
    this.hasValue = true;
    this.fileName = (this.labelKey || 'capture') + '_webcam_capture.jpg';
    const compressedB64 = await compressFile(base64Image, 500 * 1024, {isBytes: true});
    this.captured.emit(compressedB64);
    this.closeCamera();
  }
}
